import { createBrowserRouter } from 'react-router-dom'
import { Layout } from './components/layout/Layout'
import { HomePage } from './pages/HomePage'
import { PostPage } from './pages/PostPage'
import { SearchPage } from './pages/SearchPage'
import { TagPage } from './pages/TagPage'
import { CategoryPage } from './pages/CategoryPage'
import { AboutPage } from './pages/AboutPage'
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage'
import { TermsPage } from './pages/TermsPage'
import { NotFoundPage } from './pages/NotFoundPage'
import { SubscribeConfirmPage } from './pages/SubscribeConfirmPage'
import { SubscribeConfirmedPage } from './pages/SubscribeConfirmedPage'
import { SubscribeUnsubscribePage } from './pages/SubscribeUnsubscribePage'
import { SubscribeUnsubscribedPage } from './pages/SubscribeUnsubscribedPage'
import { SubscribeErrorPage } from './pages/SubscribeErrorPage'

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: 'posts/:slug',
        element: <PostPage />,
      },
      {
        path: 'search',
        element: <SearchPage />,
      },
      {
        path: 'tags/:tag',
        element: <TagPage />,
      },
      {
        path: 'category/:category',
        element: <CategoryPage />,
      },
      {
        path: 'about',
        element: <AboutPage />,
      },
      {
        path: 'privacy',
        element: <PrivacyPolicyPage />,
      },
      {
        path: 'terms',
        element: <TermsPage />,
      },
      // Subscription flow — active handlers (read token, call API, show result)
      {
        path: 'subscribe/confirm',
        element: <SubscribeConfirmPage />,
      },
      {
        path: 'subscribe/unsubscribe',
        element: <SubscribeUnsubscribePage />,
      },
      // Static result pages (kept for any legacy redirects)
      {
        path: 'subscribe/confirmed',
        element: <SubscribeConfirmedPage />,
      },
      {
        path: 'subscribe/unsubscribed',
        element: <SubscribeUnsubscribedPage />,
      },
      {
        path: 'subscribe/error',
        element: <SubscribeErrorPage />,
      },
      {
        path: '*',
        element: <NotFoundPage />,
      },
    ],
  },
])
